import React from 'react'

import {Index} from '../components';

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js